import { Directive, Input, Self, Optional } from '@angular/core';
import { FormGroupDirective, FormGroup } from '@angular/forms/';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { MatButton, MatMenuItem } from '@angular/material';

@Directive({
  selector: '[brdDisablePermission]'
})
export class DisablePermissionDirective {
  private _permissions: string | string[];
  private _keepDisabled: boolean = false;

  @Input('brdDisablePermission')
  set permission(permissions: string | string[]) {
    this._permissions = permissions;
    this.updateDisabled();
  }

  @Input('keepDisabled')
  set keepDisabled(keepDisabled: boolean) {
    this._keepDisabled = keepDisabled;
    this.updateDisabled();
  }

  constructor(private currentUserService: CurrentUserService,
    @Optional() @Self() private formGroupDirective?: FormGroupDirective,
    @Optional() @Self() private button?: MatButton,
    @Optional() @Self() private menuItem?: MatMenuItem) { }

  private updateDisabled() {
    if (this.formGroupDirective) {
      this.setDisabled(this.formGroupDirective.form, this._keepDisabled || !this.currentUserService.hasPermission(this._permissions));
    }
    if (this.button) {
      this.button.disabled = this._keepDisabled || !this.currentUserService.hasPermission(this._permissions);
      if (this.button.disabled) {
        this.button._getHostElement().style.display = 'none';
      } else {
        this.button._getHostElement().style.display = null;
      }
    }
    if (this.menuItem) {
      this.menuItem.disabled = this._keepDisabled || !this.currentUserService.hasPermission(this._permissions);
      if (this.menuItem.disabled) {
        this.menuItem._getHostElement().style.display = 'none';
      } else {
        this.menuItem._getHostElement().style.display = null;
      }
    }
  }

  private setDisabled(form: FormGroup, disable: boolean) {
    if(form){
      for (const field in form.controls) { 
        const control = form.get(field); 
        if (disable && !control.disabled) {
          control.disable();
        } else if (!disable && control.disabled) {
          control.enable();
        }
      }
  }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/disable-permission.directive.ts